import React, { useEffect, useRef, useState } from 'react';
import './style.css';
import {ReactComponent as LaptopMac} from '../../assets/images/laptop-mac.svg';
// import {ReactComponent as OnAllScreen1} from '../../assets/images/on-all-screen-1.svg';
// import {ReactComponent as OnAllScreen2} from '../../assets/images/on-all-screen-2.svg';
import OnAllScreen1 from '../../assets/images/img1.png';
import OnAllScreen2 from '../../assets/images/img2.png'
import {ReactComponent as Pamphlet} from '../../assets/images/pamphlet.svg';
import {ReactComponent as Mobile} from '../../assets/images/mobile.svg';
import ipad from '../../assets/images/ipad.png';
import mobile from '../../assets/images/mobile.svg';
import pamphlet from '../../assets/images/pamphlet.svg';
import {gsap, ScrollTrigger} from 'gsap/all';
import { ReactComponent as Figma } from '../../assets/images/figma.svg';
import { ReactComponent as Sketch } from '../../assets/images/sketch.svg';
gsap.registerPlugin(ScrollTrigger);

export default function OnAllScreens() {

  const [fixed, setFixed] = useState(false);
  const [atLast, setAtLast] = useState(false);

  let height = window.innerHeight + 'px';
  let wrapperRef = useRef(null);
  let lastImageRef = useRef(null);
  let fadeInImageRef = useRef(null);
  let fadeIn1 = useRef(null);
  let fadeIn2 = useRef(null);

  useEffect(() => {
    gsap.to(wrapperRef.current, {
      scrollTrigger: {
        trigger: wrapperRef.current,
        start: '+50px 5%',
        end: '+50px 0%',
        onEnter: () => {
          setFixed(true);
        },
        onLeaveBack: () => {
          setFixed(false);
        }
      }
    });

    gsap.to(lastImageRef.current, {
      scrollTrigger: {
        trigger: lastImageRef.current,
        start: '+10px 0%',
        end: '+10px 0%',
        // markers: true,
        onEnter: () => {
          // document.getElementsByClassName('circle')[0].style.display = 'none';
          setFixed(false);
          setAtLast(true);
        },
        onLeaveBack: () => {
          setFixed(true);
          setAtLast(false);
        }
      }
    });

    gsap.fromTo([fadeInImageRef.current.childNodes],
      {
        opacity: 0
      },
      {
        scrollTrigger: {
          trigger: fadeInImageRef.current,
          scrub: true,
        //  markers: true,
          start: '+350px 90%',
          end: '+450px 50%'
        },
      opacity: 1,
      duration: 5
    });
  }, []);

  return (
    <div 
      ref={wrapperRef} 
      className='relative onall-wrapper w-full flex flex-wrap min-h-screen items-center px-20 pb-24 overflow-auto '>
      <div ref={fadeInImageRef} className='w-1/2 image-wrapper px-10 justify-center text-center'>
        <div className='flex items-center' style={{height}}>
          <img src={OnAllScreen1} 
            style={{width: '110%'}} 
            width='470' height='360'  
            alt="Image of a desktop screen showing how illustrations from Hey! library can be executed into web products.
            The text on the image is — The best customer experiences.
            Hey! is an expression similar to hello or hola  in Spanish or it's a way to attract attention or expresses annoyance.
            Image of a mock button that says Free Trial."
          />
        </div>
        <div ref={lastImageRef} className='flex items-center' style={{height}}>
          <img src={OnAllScreen2} 
            style={{width: '110%'}}
            width='470' height='360'
            alt="Image 1 of a mobile screen showing how illustrations from Hey! library can be executed into web products. 
            The text on the image is — Hey serves many moods.
            Hey! is an expression similar to hello or hola in Spanish or it's a way to attract attention or expresses annoyance. 
            
            Image 2 of a mobile screen showing how illustrations from the Hey! library can be executed into web products. 
            The text on the image is —  From around the world, to your fingertips.
            Now get your favourite brands from all over the world. A variety of new collection waiting for you to pick. 
            Image of a mock button that says Get Started."
          />
        </div>
        {/* <div ref={fadeIn1} className='flex items-center' style={{height}}>
          <img className='mx-auto' alt='iPad' src={ipad} style={{width: '70%'}}/>
        </div>
        <div ref={fadeIn2} className='flex items-center' style={{height}}>
          <img className='mx-auto' alt='smartphone' src={mobile} style={{width: '50%'}}/>
        </div>
        <div ref={lastImageRef} className='flex items-center bg-red-30' style={{height}}>
          <img className='mx-auto' alt='pamphlet' src={pamphlet} style={{width: '50%'}}/>
        </div> */}
      </div>
      <div
        style={(atLast === true && fixed === false) ? {
          height,
          position: 'absolute',
          top: `${lastImageRef.current.offsetTop}px`,
          right: '81px',
          width: '44.4%',
        }:{
          height: height, 
          position: fixed ? 'fixed': 'relative',
          right: fixed ? '81px' : '',
          top: fixed ? '0' : '',
          width: fixed ? '44.4%' : '',
        }}
        className='w-1/2 text-wrapper items-center flex flex-wrap px-4 self-start'>
        <div>
          <h1 className='text-5xl font-extrabold w-full main-font' style={{lineHeight: '75px'}}>Hey is not work,</h1>
          <h1 className='text-5xl font-extrabold w-full main-font' style={{lineHeight: '75px'}}>it's a playground.</h1>
          {/* <h1 className='text-6xl font-bold w-full' style={{lineHeight: '75px'}}>and everywhere!</h1> */}
          <p className='md:w-3/4 mt-4 text-lg subtext secondary-font '>Explore and have fun creating artworks while you are here.</p>
          <div className="flex pt-4">
            <div className='flex justify-center items-center bg-white w-10 h-10 rounded-full open-link' style={{zIndex:30}} >
              <a href="https://gum.co/kyoKZ" className="open-link" aria-label="Figma Icon"><Figma /></a>
            </div>
            <div className='flex justify-center items-center bg-white w-10 h-10 rounded-full ml-4 open-link' style={{zIndex:30}} >
              <a href="https://gum.co/kyoKZ" className="open-link" aria-label="Sketch Icon"> <Sketch /> </a> 
            </div>
          </div>
        </div>
        {/* <div className='absolute bottom-0 right-0'>
          <h1 className='text-6xl font-bold w-full' style={{lineHeight: '75px'}}>Meant for </h1>
          <h1 className='text-6xl font-bold w-full' style={{lineHeight: '75px'}}>anywhere,</h1>
          <h1 className='text-6xl font-bold w-full' style={{lineHeight: '75px'}}>and everywhere!</h1>
          <p className='mt-4 text-lg subtext'>Add personality and character to your digital projects on multiple platforms.</p>
        </div> */}
      </div>
    </div>
  )
}
